var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7.501 14.167H5.835a4.167 4.167 0 1 1 0-8.333H7.5m5 8.333h1.667a4.167 4.167 0 1 0 0-8.333h-1.667M5.835 10h8.333"
})));
export { SvgLinkIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/linkIcon.3db53cf96aed01fbfe42e9bcca11bbc0.svg";